import type { MatchCandidateRow, MatchSide } from '~/entities/document-agent'

export const MATCH_SIDES: MatchSide[] = ['claim', 'pa']

/** The document's final side first. */
export function orderSides(finalSide: MatchSide | null): MatchSide[] {
  return finalSide === 'pa' ? ['pa', 'claim'] : MATCH_SIDES
}

export function getRowValue(row: MatchCandidateRow, key: string): unknown {
  if (key === 'name') {
    return [row.patient_first_name, row.patient_last_name].filter(Boolean).join(' ') || null
  }
  return row[key]
}

export function formatMatchValue(value: unknown): string | null {
  if (value === null || value === undefined || value === '') return null
  if (Array.isArray(value)) return value.length ? value.map(String).join(', ') : null
  if (typeof value === 'number') return Number.isInteger(value) ? String(value) : value.toFixed(2)
  if (typeof value === 'boolean') return value ? 'yes' : 'no'
  if (typeof value === 'object') return JSON.stringify(value)
  return String(value)
}

/** Criteria with a value, without the row limit. */
export function getSentCriteria(criteria: Record<string, unknown> | null): Array<[string, string]> {
  return Object.entries(criteria ?? {})
    .filter(([key]) => key !== 'limit')
    .map(([key, value]): [string, string | null] => [
      key,
      formatMatchValue(value === false ? null : value),
    ])
    .filter((entry): entry is [string, string] => entry[1] !== null)
}

const METHOD_WORDS: Record<string, string> = {
  dob: 'DOB',
  dos: 'DOS',
  id: 'ID',
  pa: 'PA',
  mrn: 'MRN',
}

/** A matching rule's method name in words: `name_dob_dos` → "name + DOB + DOS". */
export function formatMethod(method: string | null | undefined): string {
  if (!method) return 'matching'
  return method
    .replace(/_id\b/g, ' id')
    .split('_')
    .map((part) =>
      part
        .split(' ')
        .map((word) => METHOD_WORDS[word] ?? word)
        .join(' '),
    )
    .join(' + ')
}
